import { createFileRoute } from "@tanstack/react-router";

import DataAnalysisOverview from "~/pages/DataAnalysisOverview";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/data-analysis-overview/$")({
  staticData: ROUTE_STATIC.dataAnalysisOverview,
  component: DataAnalysisOverview,
});
